// nav
import dashboardNavConfig from '../dashboard/nav/config-navigation';

// ----------------------------------------------------------------------

export const MARKETING_ASSETS_ROOT = '/marketingassets';

const DEALER_MARKETING_ROOT = '/dealerportal/marketing';

// Admin-only pages that must never be exposed on the public route.
const EXCLUDED_PATHS = [
  `${DEALER_MARKETING_ROOT}/modelgalleryupload`,
  `${DEALER_MARKETING_ROOT}/upload-social-media`,
];

// Rewrites /dealerportal/marketing/... -> /marketingassets/...
// Tolerates undefined / '' / absent paths and leaves external links alone.
function rewritePath(path) {
  if (typeof path !== 'string' || path === '') {
    return path;
  }

  if (path.startsWith(DEALER_MARKETING_ROOT)) {
    return `${MARKETING_ASSETS_ROOT}${path.slice(DEALER_MARKETING_ROOT.length)}`;
  }

  return path;
}

function transformItems(items = []) {
  return items
    .filter((item) => !(typeof item.path === 'string' && EXCLUDED_PATHS.includes(item.path)))
    .map((item) => {
      // Shallow copy preserves icon (JSX element), target, caption, info, disabled.
      const next = { ...item };

      if ('path' in item) {
        next.path = rewritePath(item.path);
      }

      if (Array.isArray(item.children)) {
        const children = transformItems(item.children);

        if (children.length) {
          next.children = children;
        } else {
          delete next.children;
        }
      }

      return next;
    });
}

// Located by title so reordering config-navigation.js cannot break this.
const marketingItem = dashboardNavConfig
  .flatMap((group) => group.items || [])
  .find((item) => item.title === 'Marketing');

if (!marketingItem && process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line no-console
  console.warn(
    '[marketingassets] No nav item titled "Marketing" found in dashboard config-navigation.js'
  );
}

const marketingNavConfig = [
  {
    subheader: 'Marketing Assets',
    items: transformItems(marketingItem?.children),
  },
];

export default marketingNavConfig;
